import React from 'react';
import classNames from 'classnames';
import {ReactComponent as Icon} from 'images/icon/edit.svg';

export default class EditIcon extends React.PureComponent {
  render() {
    return (
      <Icon
        className={classNames('icon edit', this.props.className)}
        onClick={this.props.onClick}
      />
    );
  }
}
